import { PERSIST_KEY, TOKEN } from 'constants/local-storage-keys';
import { removeKey } from './local-storage';
import { persistorStore } from 'redux/store';

export const removeUser = () => {
    removeKey(PERSIST_KEY);
    removeKey(TOKEN);
    persistorStore.purge();
};
